import { render, staticRenderFns } from "./IndexList.vue?vue&type=template&id=6bc0b6da&scoped=true"
import script from "./IndexList.vue?vue&type=script&lang=js"
export * from "./IndexList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc0b6da",
  null
  
)

export default component.exports